import { Typography } from '@mui/material'
import { ColDef, GridReadyEvent, ICellRendererParams } from 'ag-grid-community'
import { PLACEHOLDER } from 'components/column-renderers'
import dateRenderer from 'components/column-renderers/date'
import InfinityAgGrid from 'components/table/InfinityAgGrid'
import { UIModal } from 'features/UI'
import { useShowControl } from 'hooks/useShowControl'
import React, { SyntheticEvent, useMemo } from 'react'
import { ShortTeamInfo, UserUpdater } from 'types'

export function TeamsCell({
  teamCount,
  invitedTeams,
  createdTeams,
}: {
  teamCount: number
  invitedTeams: ShortTeamInfo[]
  createdTeams: ShortTeamInfo[]
}) {
  const [isOpen, onOpen, onClose] = useShowControl()

  const handleOpen = (event: SyntheticEvent) => {
    event.preventDefault()
    onOpen()
  }

  const handleGridReady = (event: GridReadyEvent) => {
    event.api.sizeColumnsToFit()
  }

  const createdTeamsColumnDefs: ColDef[] = useMemo(() => {
    return [
      {
        headerName: 'Team Name',
        field: 'name',
      },
      {
        headerName: 'Created Date',
        cellRenderer: dateRenderer('createdAt'),
        colId: 'createdAt',
      },
      {
        headerName: 'Members',
        field: 'membersCount',
      },
    ]
  }, [])

  const invitedTeamsColumnDefs: ColDef[] = useMemo(() => {
    return [
      {
        headerName: 'Team Name',
        field: 'name',
      },
      {
        headerName: 'Invited By',
        colId: 'invitedBy',
        field: 'invitedBy',
        sortable: false,
        cellRenderer: (props: ICellRendererParams) => {
          if (!props.data) return PLACEHOLDER

          const updater: UserUpdater = props.data.invitedBy
          if (!updater) return PLACEHOLDER

          return <div>{`${updater.firstname} ${updater.lastname}`}</div>
        },
      },
      {
        headerName: 'Created Date',
        cellRenderer: dateRenderer('createdAt'),
        colId: 'createdAt',
      },
      {
        headerName: 'Members',
        field: 'membersCount',
      },
    ]
  }, [])

  return (
    <div>
      <a href="" onClick={handleOpen}>
        {teamCount}
      </a>

      <UIModal isOpen={isOpen} onClose={onClose} width={1188} title="Teams">
        <Typography variant="h6" color="textSecondary" gutterBottom>
          Created Teams
        </Typography>
        <div
          className="ag-theme-alpine"
          style={{ height: '400px', width: '1140px', fontSize: '1rem' }}
        >
          <InfinityAgGrid
            rowData={createdTeams}
            columnDefs={createdTeamsColumnDefs}
            rowModelType="clientSide"
            onGridReady={handleGridReady}
            floatingFiltersHeight={0}
          />
        </div>

        <Typography variant="h6" color="textSecondary" mt={4} gutterBottom>
          Invited Teams
        </Typography>
        <div
          className="ag-theme-alpine"
          style={{ height: '400px', width: '1140px', fontSize: '1rem' }}
        >
          <InfinityAgGrid
            rowData={invitedTeams}
            columnDefs={invitedTeamsColumnDefs}
            rowModelType="clientSide"
            onGridReady={handleGridReady}
            floatingFiltersHeight={0}
          />
        </div>
      </UIModal>
    </div>
  )
}
